$(document).ready(function () {
  $(`.fancybox`).fancybox({
    maxWidth: 940,
    maxHeight: 600,
    width: `100%`,
    height: `70%`,
    closeClick: false,
    padding: 0,
  });

  $(`.video`).fancybox({
    maxWidth: 940,
    autoplay: true,
    fitToView: true,
    autoSize: false,
    closeClick: false,
    openEffect: `none`,
    closeEffect: `none`,
    padding: 0
  });
});
